export function hypotenuse(a, b) {
  var r = 0;

  if (Math.abs(a) > Math.abs(b)) {
    r = b / a;
    return Math.abs(a) * Math.sqrt(1 + r * r);
  }

  if (b !== 0) {
    r = a / b;
    return Math.abs(b) * Math.sqrt(1 + r * r);
  }

  return 0;
}
export function getFilled2DArray(rows, columns, value) {
  var array = new Array(rows);

  for (var i = 0; i < rows; i++) {
    array[i] = new Array(columns);

    for (var j = 0; j < columns; j++) {
      array[i][j] = value;
    }
  }

  return array;
}